"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        default:
            {
                // This is for default server initialization with data from bundler
                return action.securityKeys ? Object.assign({}, state, action.securityKeys) : state;
            }
    }
};
exports.default = reducer;
